import { style } from '@vanilla-extract/css';
import { vars } from '@/shared/ui/theme/contract.css';

/** 선택 줄 — 두 칸 토글 · 리전 미상 · 조회 시각이 한 줄에 선다(퀘스트 2f546c56 B안). */
export const bar = style({
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: vars.spacing.gap.sm,
});

export const toggle = style({
  display: 'flex',
  gap: vars.spacing.gap.xs,
});

export const strong = style({
  fontVariantNumeric: 'tabular-nums',
});

export const meta = style({
  fontSize: vars.typography.fontSize.xs,
  color: vars.typography.textColor.tertiary,
});

export const snapshot = style({
  marginLeft: 'auto',
  fontSize: vars.typography.fontSize['2xs'],
  color: vars.typography.textColor.softMuted,
});

export const pick = style({
  display: 'flex',
  alignItems: 'center',
  gap: vars.spacing.gap.xs,
});

export const pickInput = style({
  width: '9rem',
});
